import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const whatsappNumber = "919727983039";

  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      "Hello, I would like to enquire about ordering on WhatsApp."
    );
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, "_blank");
  };

  return (
    <footer className="hm-footer">
      <div className="hm-footer-container">
        {/* Main Footer Grid */}
        <div className="hm-footer-grid">
          {/* Column 1: Brand Info */}
          <div className="hm-footer-col hm-footer-brand">
            <Link to="/" className="hm-footer-logo-link">
              <img
                src="/images/Logo.png"
                alt="MultiFct"
                className="hm-footer-logo-img"
              />
            </Link>
            <span className="hm-footer-tagline">
              SMART ADHESIVES &amp; STORAGE SOLUTIONS
            </span>
            <p className="hm-footer-desc">
              Thoughtfully designed products that keep your everyday repairs,
              crafts, and home essentials sorted and easy to find.
            </p>

            <button
              className="hm-footer-whatsapp-btn"
              onClick={handleWhatsApp}
            >
              <svg
                className="hm-footer-wa-icon"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20.5 3.5A11.7 11.7 0 0 0 12.1 0C5.6 0 .3 5.3.3 11.8c0 2.1.5 4.1 1.6 5.9L.2 24l6.4-1.7a11.8 11.8 0 0 0 5.5 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.1 21.7c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4a9.8 9.8 0 1 1 8.5 4.7Zm5.4-7.4c-.3-.2-1.7-.9-2-.9-.3-.1-.5-.2-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.2-.5-2.3-1.5-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.9-2-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.2 5 4.5.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.1-1.4-.1-.1-.3-.2-.6-.4Z" />
              </svg>
              Order on WhatsApp
            </button>
          </div>

          {/* Column 2: Explore */}
          <div className="hm-footer-col hm-footer-links">
            <h4 className="hm-footer-heading">Explore</h4>
            <ul className="hm-footer-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/shop">Shop</Link>
              </li>
              <li>
                <Link to="/wishlist">Wishlist</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Reach Us */}
          <div className="hm-footer-col hm-footer-contact">
            <h4 className="hm-footer-heading">Reach us</h4>
            <ul className="hm-contact-list">
              {/* Phone */}
              <li className="hm-contact-item">
                <svg
                  className="hm-contact-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <a href="tel:+919727983039">+91 9727983039</a>
              </li>

              {/* Email */}
              <li className="hm-contact-item">
                <svg
                  className="hm-contact-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect width="20" height="16" x="2" y="4" rx="2" />
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                </svg>
                <a href="mailto:contact@multifct.online">contact@multifct.online</a>
              </li>

              {/* Address */}
              <li className="hm-contact-item hm-contact-address">
                <svg
                  className="hm-contact-icon hm-address-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>
                  Road No. 04, Nr. Kotak Bank, Sachin, Surat, Gujarat - 394230
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright Bar */}
        <div className="hm-footer-bottom">
          <p className="hm-footer-copy">
            © 2026 MultiFct. All rights reserved.
          </p>
          <p className="hm-footer-proprietor">
            MultiFct · Murlidhar Enterprise
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
